import { render, staticRenderFns } from "./HandHeart.vue?vue&type=template&id=7c983819&scoped=true&"
var script = {}
import style0 from "./HandHeart.vue?vue&type=style&index=0&id=7c983819&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c983819",
  null
  
)

export default component.exports